import styled from '@emotion/styled'

import type { FC, PropsWithChildren } from 'react'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Navigation from '@segment/templates/Navigation'
import Footer from '@segment/templates/Footer'
import GettingStarted from '@segment/templates/GettingStarted'

import Layout from '@segment/next-shared/layout'

import Resources from './components/Resources'
import TwilioDeveloperPlan from './components/TwilioDeveloperPlan'
import AccessibleAi from './components/AccessibleAi'
import UnifyCustomerProfile from './components/UnifyCustomerProfile'
import PersonalizeOnEveryChannel from './components/PersonalizeOnEveryChannel'
import CustomerDataFoundation from './components/CustomerDataFoundation'
import BuildIntelligentCustomerEngagement from './components/BuildIntelligentCustomerEngagement'
import Hero from './components/Hero'
import LogoCarousel from './components/LogoCarousel'

const copy = {
  title: `See what Twilio + Segment can do for you | Twilio Segment`,
  description: `Unlock the power of your customer data and make every engagement more personal and impactful`,
}

const CustomerEngagementView: FC<PropsWithChildren<unknown>> = () => {
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout pageTitle={copy.title} pageDescription={copy.description}>
        <Navigation />
        <Main>
          <Hero />
          <LogoCarousel />
          <BuildIntelligentCustomerEngagement />
          <CustomerDataFoundation />
          <UnifyCustomerProfile />
          <AccessibleAi />
          <PersonalizeOnEveryChannel />
          <TwilioDeveloperPlan />
          <ResourcesWrapper>
            <Resources />
          </ResourcesWrapper>
          <GettingStarted />
        </Main>
      </Layout>
      <Footer />
    </AppearanceProvider>
  )
}

const Main = styled.main`
  background: ${({ theme }) => theme.palette.neutrals.white[100]};
`

const ResourcesWrapper = styled.div`
  background: ${({ theme }) => theme.palette.twilio.gray[10]};
`

export default CustomerEngagementView
